.image {
  width: 300px;
}
